import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { SaleGetDocumentDTO } from '@skylab-shared/dataModel';
import { fillPlaceholders } from '@skylab-shared/utils';

export class SaleAdvancePlainObjectQuery extends Query<SaleGetDocumentDTO> { }

export class SaleAdvancePlainObjectQueryHandlerBase implements QueryHandler<SaleAdvancePlainObjectQuery, SaleGetDocumentDTO> {
    private static Url = TaggedUrl.join('sales/:id', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(_: SaleAdvancePlainObjectQuery, id: number): Promise<SaleGetDocumentDTO> {
        const { data } = await this.http.get(fillPlaceholders(SaleAdvancePlainObjectQueryHandlerBase.Url, { id: id }), {dto: SaleGetDocumentDTO});
        return data;
    }
}
